export default {
    install (Vue, options) {
        Vue.prototype.isResponseOk = (response) => (200 <= response.status && response.status <= 299)

        Vue.prototype.isResponseError = (response) => (response.status >= 400)

        Vue.prototype.getResponseValidationErrors = (response) => (response && response.data && response.data.errors ? response.data.errors : {})

        Vue.prototype.setQuery = (data) => {
            const query = JSON.stringify(data)
            if (JSON.stringify(Vue.prototype.getQuery()) === query) {
                return
            }
            const search = '?' + encodeURIComponent(query)
            history.pushState(null, null, search)
        }

        Vue.prototype.getQuery = () => {
            try {
                const query = decodeURIComponent(location.search.slice(1))
                const data = JSON.parse(query)
                return data
            } catch (e) {
                return {}
            }
        }

        Vue.prototype.download = (response) => {
            var fileName = response.headers['content-disposition'].match(/filename=\"{0,1}([^\"]+)\"{0,1}/)[1]
            var contentType = response.headers['content-type']

            if (!response.data) {
                return
            }

            if (navigator.appVersion.toString().indexOf('.NET') > 0) {
                var uint8_array = new Uint8Array(response.data)
                var blob = new Blob([ uint8_array ], { type: contentType });
                window.navigator.msSaveBlob(blob, fileName)
            } else {
                var file = new File([response.data], fileName, {type: contentType})
                Vue.prototype.$fileSaver.saveAs(file)
            }
        }

        //    Vue.directive('qiita-click', {
        //      bind: (el) => {
        //        el.addEventListener('click', click, false)
        //      }
        //    })
        //
        //    const click = () => {
        //      console.log('qiita!!')
        //    }
    }
}


